import { render, staticRenderFns } from "./CharactersAdd.vue?vue&type=template&id=0f6a359d&scoped=true&"
import script from "./CharactersAdd.vue?vue&type=script&lang=js&"
export * from "./CharactersAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a359d",
  null
  
)

export default component.exports